var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCirclePrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 0.333008C3.31998 0.333008 0.333313 3.31967 0.333313 6.99967C0.333313 10.6797 3.31998 13.6663 6.99998 13.6663C10.68 13.6663 13.6666 10.6797 13.6666 6.99967C13.6666 3.31967 10.68 0.333008 6.99998 0.333008ZM7.66665 10.333H6.33331V8.99967H7.66665V10.333ZM7.66665 7.66634H6.33331V3.66634H7.66665V7.66634Z",
    fill: "#BFA1FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCirclePrimary);
export default __webpack_public_path__ + "static/media/info-circle-primary.e808e9d20d04de1deec7a36b305735d8.svg";
export { ForwardRef as ReactComponent };